import { render, staticRenderFns } from "./FeaturedCapabilities.vue?vue&type=template&id=1630bea8&scoped=true&"
import script from "./FeaturedCapabilities.vue?vue&type=script&lang=js&"
export * from "./FeaturedCapabilities.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCapabilities.vue?vue&type=style&index=0&id=1630bea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630bea8",
  null
  
)

component.options.__file = "FeaturedCapabilities.vue"
export default component.exports